<template>
  <div class="navbar-container">
    <!-- 切换sidebar -->
    <ToggleSidebar :collapse="isCollapse" @toggleMenu="handleChangeCollapse" />
    <!-- 面包屑导航 -->
    <BreadCrumb />
    <!-- 右侧 下拉栏 -->
    <RightMenu class="right-menu" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import ToggleSidebar from "./ToggleSidebar";
import BreadCrumb from "@/components/Breadcrumb";
import RightMenu from "./Rightmenu";
export default {
  computed: {
    ...mapState("layout", ["isCollapse"]),
  },
  components: {
    ToggleSidebar,
    BreadCrumb,
    RightMenu,
  },
  methods: {
    handleChangeCollapse() {
      this.$store.commit("layout/SET_COLLAPSE");
    },
  },
};
</script>
<style lang="less" scoped>
.navbar-container {
  overflow: hidden;
  width: 100%;
  height: 50px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .right-menu {
    float: right;
    margin-right: 30px;
  }
}
</style>